import {createFeatureSelector, createSelector} from '@ngrx/store';
import {State} from "./store.reducer";

export const selectFeature = createFeatureSelector<State>('Store');

export const StoreSelector = {
	selectRequestProcessing: createSelector(
		selectFeature,
		(state) => state.requestProcessing
	),
	selectStoreDetail: createSelector(
		selectFeature,
		(state) => state.store
	),
	selectGetStoresRequestProcessing: createSelector(
		selectFeature,
		(state) => state.GetStores.requestProcessing
	),
	selectGetStoresCriteria: createSelector(
		selectFeature,
		(state) => state.GetStores.criteria
	),
	selectGetStoresResonse: createSelector(
		selectFeature,
		(state) => state.GetStores.response
	),
};
